import { logEvent } from 'commons/utils/tracking';
import {
  SETTINGS_EXTERNALCODES_GOOGLE_GA4TOKEN_AUTHORIZE_ATTEMPT,
  MENU_SETTINGS_EXTERNALCODES_VIEW,
  MENU_SECONDARY_PREFERENCES_ADVANCED_CLICK,
} from 'config/trackingEvents';
import {
  GA4_LINKED_FALSE_VALUE,
  GA4_LINKED_TRUE_VALUE,
  GA4_TOKEN_AUTHORIZED,
  GA4_TOKEN_NON_AUTHORIZED,
  GTM_LINKED_FALSE_VALUE,
  GTM_LINKED_TRUE_VALUE,
} from './constants';

export const menuSecondaryExternalCodesClick = () => {
  logEvent(MENU_SECONDARY_PREFERENCES_ADVANCED_CLICK, {});
};

export const menuSettingsExternalCodesView = (
  gtmLinked: boolean,
  ga4Linked: boolean,
  ga4DataApiOAuthGiven: boolean,
) => {
  logEvent(MENU_SETTINGS_EXTERNALCODES_VIEW, {
    gtm_linked: gtmLinked ? GTM_LINKED_TRUE_VALUE : GTM_LINKED_FALSE_VALUE,
    ga4_linked: ga4Linked ? GA4_LINKED_TRUE_VALUE : GA4_LINKED_FALSE_VALUE,
    ga4_token: ga4DataApiOAuthGiven
      ? GA4_TOKEN_AUTHORIZED
      : GA4_TOKEN_NON_AUTHORIZED,
  });
};

export const ga4DataApiOAuthButtonClick = (measurementId: string) => {
  logEvent(SETTINGS_EXTERNALCODES_GOOGLE_GA4TOKEN_AUTHORIZE_ATTEMPT, {
    measurement_id: measurementId,
  });
};
